import { render, staticRenderFns } from "./activateWallet.vue?vue&type=template&id=38e9fe60"
import script from "./activateWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./activateWallet.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports